// extracted by mini-css-extract-plugin
export default {"character_list":"CharacterList_character_list__DXIL1","character":"CharacterList_character__Oahpv","pagination":"CharacterList_pagination__Ygahp"};